exports = module.exports = require("../../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2Z5l7eRwV89HSlh8QHJAkL{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;margin-top:1rem;width:100%}._2Z5l7eRwV89HSlh8QHJAkL>div{-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1}@media (min-width: 992px){._2Z5l7eRwV89HSlh8QHJAkL>div{max-width:17.85714rem}}._2Z5l7eRwV89HSlh8QHJAkL>button{margin-left:1.5rem;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;-webkit-transition:unset;transition:unset}._2Z5l7eRwV89HSlh8QHJAkL.has-remaining-attemps>button{margin-top:2.4rem}\n", ""]);

// exports
exports.locals = {
	"authInputBlock": "_2Z5l7eRwV89HSlh8QHJAkL"
};